// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__dYomX","hidden":"spinner_hidden__oYsv2","dot":"spinner_dot__9Z+bl","pulse":"spinner_pulse__KcJJw","message":"spinner_message__8dxIx"};